var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editor_text"}},[_c('editorTextChapter'),_c('editorTextContext')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }